export default "__VITE_ASSET__g9wvL_eF__"